/* bh-devis.js — Page devis BarberHouse (v3, 07/10/2026)
   Données : #bhCatalog (rendu Liquid, tous les produits publiés), #bhCartData (panier Shopify).
   Sélection conservée en localStorage (bh_devis_v2), dernière demande envoyée en sessionStorage.
   Suivi : Shopify.analytics.publish (événements personnalisés bh_devis_*). */
(function () {
  'use strict';
  var root = document.getElementById('bh-devis');
  if (!root) return;

  var STORE_KEY = 'bh_devis_v2';
  var LAST_KEY = 'bh_devis_last';
  var VIEW_KEY = 'bh_devis_view';
  var PAGE_SIZE = 24;
  var PRICE_NOTE = root.getAttribute('data-price-note') || '';
  var isMobile = function () { return window.matchMedia('(max-width: 989px)').matches; };
  var $ = function (sel) { return root.querySelector(sel); };

  // ---------- Utilitaires ----------
  function norm(s) { return (s || '').toString().toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); }
  function esc(s) { return (s == null ? '' : String(s)).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(c) { return (c / 100).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €'; }
  function ht(ttc, rate) { return Math.round(ttc * 100 / (100 + rate)); }
  function store(k, v, session) { try { (session ? sessionStorage : localStorage).setItem(k, JSON.stringify(v)); } catch (e) {} }
  function load(k, session) { try { return JSON.parse((session ? sessionStorage : localStorage).getItem(k)); } catch (e) { return null; } }
  function track(name, data) {
    try { if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') Shopify.analytics.publish(name, data || {}); } catch (e) {}
  }
  function toast(msg) {
    var el = document.createElement('div');
    el.className = 'bh-devis__toast'; el.setAttribute('role', 'status'); el.textContent = msg;
    root.appendChild(el); setTimeout(function () { el.remove(); }, 2600);
  }

  // ---------- Catalogue ----------
  var CATALOG = [];
  try { CATALOG = JSON.parse($('#bhCatalog').textContent); } catch (e) { console.error('[BarberHouse] Catalogue devis illisible', e); }
  var byVariant = {}, byHandle = {};
  CATALOG.forEach(function (p, idx) {
    p.o = idx;
    p.x = parseFloat(p.x); if (isNaN(p.x)) p.x = 20;
    var parts = p.t.split(' - ');
    p.main = parts[0];
    p.sub = parts.slice(1).join(' - ');
    p.min = Math.min.apply(null, p.vs.map(function (v) { return v.p; }));
    p.key = norm([p.t, p.v, p.vs.map(function (v) { return v.s + ' ' + v.t; }).join(' ')].join(' '));
    byHandle[p.h] = p;
    p.vs.forEach(function (v) { byVariant[v.id] = { p: p, v: v }; });
  });
  function thumb(p, w) { return p.i ? p.i.replace(/([?&])width=\d+/, '$1width=' + w) : ''; }

  // ---------- État ----------
  var state = { q: '', cat: '', brand: '', sort: 'default', shown: PAGE_SIZE, view: load(VIEW_KEY) === 'grid' ? 'grid' : 'list' };
  var selIdx = {}; // variante choisie par produit
  var items = (load(STORE_KEY) || []).filter(function (it) { return it && byVariant[it.id] && it.q > 0; });
  function save() { store(STORE_KEY, items); }
  function findItem(id) { for (var i = 0; i < items.length; i++) if (items[i].id === id) return items[i]; return null; }
  function setQty(id, q) {
    var it = findItem(id);
    if (q <= 0) { items = items.filter(function (x) { return x.id !== id; }); }
    else if (it) { it.q = q; }
    else { items.push({ id: id, q: q }); }
    save(); refreshAll();
  }
  function addItem(id, q, silent) {
    var it = findItem(id);
    setQty(id, (it ? it.q : 0) + q);
    var r = byVariant[id];
    if (!silent && r) { toast('« ' + r.p.main + ' » ajouté à votre devis'); track('bh_devis_add', { sku: r.v.s, quantity: q, price: r.v.p / 100 }); }
  }

  // ---------- Confirmation d'envoi ----------
  var done = $('#bhDone');
  if (done) {
    var last = load(LAST_KEY, true);
    items = []; save();
    if (last && last.items && last.items.length) {
      var rec = $('#bhDoneRecap');
      rec.innerHTML = '<strong>Récapitulatif de votre demande</strong><ul>' + last.items.map(function (it) {
        var r = byVariant[it.id]; return r ? '<li>' + esc(r.p.main) + (r.p.vs.length > 1 ? ' — ' + esc(r.v.t) : '') + ' × ' + it.q + '</li>' : '';
      }).join('') + '</ul>';
      rec.hidden = false;
      var donePdf = $('#bhDonePdf');
      donePdf.hidden = false;
      donePdf.addEventListener('click', function () { printQuote(last.items); });
    }
    $('#bhNewQuote').addEventListener('click', function () {
      done.hidden = true; $('#bhGrid').hidden = false; refreshAll();
      $('#bhGrid').scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    done.scrollIntoView({ block: 'center' });
  }

  // ---------- Filtres ----------
  var productsEl = $('#bhProducts');
  var loadMoreBtn = $('#bhLoadMore');
  var searchInput = $('#bhSearch');
  var brandSel = $('#bhBrand');
  var chips = root.querySelectorAll('.bh-devis__chip');

  var brands = {};
  CATALOG.forEach(function (p) { if (p.v) brands[p.v] = (brands[p.v] || 0) + 1; });
  Object.keys(brands).sort(function (a, b) { return a.localeCompare(b, 'fr'); }).forEach(function (b) {
    var o = document.createElement('option'); o.value = b; o.textContent = b + ' (' + brands[b] + ')'; brandSel.appendChild(o);
  });
  function inCat(p, cat) { return !cat || (cat === 'pack' ? p.pk : String(p.c) === cat); }
  chips.forEach(function (chip) {
    var cat = chip.getAttribute('data-cat');
    var n = CATALOG.filter(function (p) { return inCat(p, cat); }).length;
    chip.insertAdjacentHTML('beforeend', '<span>' + n + '</span>');
    if (cat && n === 0) chip.hidden = true;
  });

  function filtered() {
    var words = norm(state.q).split(/\s+/).filter(Boolean);
    var list = CATALOG.filter(function (p) {
      if (!inCat(p, state.cat)) return false;
      if (state.brand && p.v !== state.brand) return false;
      for (var i = 0; i < words.length; i++) if (p.key.indexOf(words[i]) === -1) return false;
      return true;
    });
    var s = state.sort;
    list.sort(function (a, b) {
      if (s === 'price-asc') return a.min - b.min;
      if (s === 'price-desc') return b.min - a.min;
      if (s === 'az') return a.t.localeCompare(b.t, 'fr');
      return a.o - b.o;
    });
    return list;
  }

  // ---------- Cartes ----------
  function badges(p) {
    var b = '';
    if (p.pk) b += '<span class="bh-devis__tag bh-devis__tag--pack">Pack</span>';
    if (p.bs) b += '<span class="bh-devis__tag bh-devis__tag--best">Best-seller</span>';
    if (p.mb) b += '<span class="bh-devis__tag">Sur commande · 7-10 j</span>';
    return b;
  }
  function currentVariant(p) { return p.vs[selIdx[p.h] || 0] || p.vs[0]; }

  function productCard(p) {
    var v = currentVariant(p);
    var it = findItem(v.id);
    var w = state.view === 'grid' ? 400 : 160;
    var img = p.i ? '<img class="bh-devis__pImg" src="' + esc(thumb(p, w)) + '" alt="" loading="lazy" width="' + (w === 400 ? 400 : 72) + '" height="' + (w === 400 ? 400 : 72) + '">' : '<div class="bh-devis__pImg"></div>';
    var opts = p.vs.length > 1 ? '<select class="bh-devis__select" data-variant aria-label="Variante">' + p.vs.map(function (x, i) {
      var sel = (selIdx[p.h] || 0) === i ? ' selected' : '';
      var inQ = findItem(x.id) ? ' ✓' : '';
      return '<option value="' + i + '"' + sel + '>' + esc(x.t) + ' — ' + money(x.p) + inQ + '</option>';
    }).join('') + '</select>' : '';
    var action = it
      ? '<span class="bh-devis__inLabel">Dans le devis</span><span class="bh-devis__qty bh-devis__qty--in"><button type="button" class="bh-devis__qtyBtn" data-dec aria-label="Diminuer">−</button><input type="number" class="bh-devis__qtyInput" data-setq value="' + it.q + '" min="0" inputmode="numeric" aria-label="Quantité dans le devis"><button type="button" class="bh-devis__qtyBtn" data-inc aria-label="Augmenter">+</button></span>'
      : '<span class="bh-devis__qty"><button type="button" class="bh-devis__qtyBtn" data-minus aria-label="Diminuer">−</button><input type="number" class="bh-devis__qtyInput" data-qty value="1" min="1" inputmode="numeric" aria-label="Quantité"><button type="button" class="bh-devis__qtyBtn" data-plus aria-label="Augmenter">+</button></span><button type="button" class="bh-devis__btn bh-devis__add" data-add>Ajouter au devis</button>';
    var delivery = p.mb ? '' : '<span class="bh-devis__muted">Livraison 24/48h</span>';
    return '<article class="bh-devis__product' + (it ? ' is-in' : '') + '" data-h="' + esc(p.h) + '">' +
      '<a class="bh-devis__pMedia" href="' + esc(p.u) + '" target="_blank" rel="noopener" tabindex="-1" aria-hidden="true">' + img + '</a>' +
      '<div class="bh-devis__pInfo">' +
        '<div class="bh-devis__pTop"><div>' +
          '<span class="bh-devis__pVendor">' + esc(p.v) + '</span>' +
          '<p class="bh-devis__pTitle"><a href="' + esc(p.u) + '" target="_blank" rel="noopener">' + esc(p.main) + '</a>' + (p.sub ? '<span class="bh-devis__pSub">' + esc(p.sub) + '</span>' : '') + '</p>' +
        '</div><div class="bh-devis__pPrice"><strong>' + money(v.p) + ' TTC</strong><small>' + money(ht(v.p, p.x)) + ' HT</small></div></div>' +
        '<div class="bh-devis__pMeta"><span class="bh-devis__pBadges">' + badges(p) + '</span>' + delivery + (v.s ? '<span class="bh-devis__muted">SKU ' + esc(v.s) + '</span>' : '') + '</div>' +
        '<div class="bh-devis__pRow">' + opts + action + '</div>' +
      '</div>' +
    '</article>';
  }

  function renderProducts() {
    var list = filtered();
    $('#bhResultCount').textContent = list.length + ' produit' + (list.length > 1 ? 's' : '');
    productsEl.className = 'bh-devis__products is-' + state.view;
    if (!list.length) {
      var q = state.q.trim();
      productsEl.innerHTML = '<div class="bh-devis__empty">Aucun produit ne correspond' + (q ? ' à « ' + esc(q) + ' »' : '') + '. Nous pouvons aussi chiffrer des références hors catalogue.' +
        (q ? '<br><button type="button" class="bh-devis__btn bh-devis__btn--outline" data-offcat>Ajouter « ' + esc(q) + ' » à ma demande</button>' : '') + '</div>';
      loadMoreBtn.hidden = true;
      return;
    }
    var page = list.slice(0, state.shown);
    productsEl.innerHTML = page.map(productCard).join('');
    var rest = list.length - page.length;
    loadMoreBtn.hidden = rest <= 0;
    loadMoreBtn.textContent = 'Voir plus de produits (' + rest + ')';
  }

  // Délégation d'événements sur la liste
  productsEl.addEventListener('click', function (e) {
    var btn = e.target.closest('button');
    if (!btn) return;
    if (btn.hasAttribute('data-offcat')) { addOffCatalog(state.q.trim()); return; }
    var card = btn.closest('.bh-devis__product'); if (!card) return;
    var p = byHandle[card.getAttribute('data-h')]; var v = currentVariant(p);
    var qtyInput = card.querySelector('[data-qty]');
    if (btn.hasAttribute('data-minus')) qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
    else if (btn.hasAttribute('data-plus')) qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1;
    else if (btn.hasAttribute('data-add')) addItem(v.id, Math.max(1, parseInt(qtyInput.value, 10) || 1));
    else if (btn.hasAttribute('data-inc')) setQty(v.id, findItem(v.id).q + 1);
    else if (btn.hasAttribute('data-dec')) setQty(v.id, findItem(v.id).q - 1);
  });
  productsEl.addEventListener('change', function (e) {
    var card = e.target.closest('.bh-devis__product'); if (!card) return;
    var p = byHandle[card.getAttribute('data-h')];
    if (e.target.hasAttribute('data-variant')) { selIdx[p.h] = parseInt(e.target.value, 10) || 0; renderProducts(); }
    else if (e.target.hasAttribute('data-setq')) { setQty(currentVariant(p).id, Math.max(0, parseInt(e.target.value, 10) || 0)); }
  });

  // Entrée dans les champs du catalogue : pas d'envoi du formulaire
  root.querySelector('.bh-devis__panel').addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.tagName === 'INPUT') { e.preventDefault(); if (e.target.hasAttribute('data-setq')) e.target.blur(); }
  });

  var searchTimer;
  searchInput.addEventListener('input', function () {
    clearTimeout(searchTimer);
    searchTimer = setTimeout(function () { state.q = searchInput.value; state.shown = PAGE_SIZE; renderProducts(); }, 150);
  });
  root.querySelectorAll('.bh-devis__quickBtn').forEach(function (b) {
    b.addEventListener('click', function () {
      searchInput.value = b.getAttribute('data-q'); state.q = searchInput.value; state.shown = PAGE_SIZE;
      renderProducts(); track('bh_devis_quick_search', { query: state.q });
    });
  });
  brandSel.addEventListener('change', function () { state.brand = brandSel.value; state.shown = PAGE_SIZE; renderProducts(); });
  $('#bhSort').addEventListener('change', function (e) { state.sort = e.target.value; renderProducts(); });
  chips.forEach(function (chip) {
    chip.addEventListener('click', function () {
      chips.forEach(function (c) { c.classList.toggle('is-active', c === chip); });
      state.cat = chip.getAttribute('data-cat'); state.shown = PAGE_SIZE; renderProducts();
    });
  });
  loadMoreBtn.addEventListener('click', function () { state.shown += PAGE_SIZE; renderProducts(); });
  root.querySelectorAll('.bh-devis__viewBtn').forEach(function (b) {
    b.addEventListener('click', function () {
      state.view = b.getAttribute('data-view'); store(VIEW_KEY, state.view);
      root.querySelectorAll('.bh-devis__viewBtn').forEach(function (x) {
        var on = x === b; x.classList.toggle('is-active', on); x.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      renderProducts();
    });
    var on = b.getAttribute('data-view') === state.view;
    b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
  });

  // ---------- Sélection (récap) ----------
  var cartEl = $('#bhCart');
  var cartList = $('#bhCartList');
  var itemsField = $('#bhItems');

  function totals(list) {
    var t = { ttc: 0, ht: 0, n: 0 };
    (list || items).forEach(function (it) {
      var r = byVariant[it.id]; if (!r) return;
      t.ttc += r.v.p * it.q; t.ht += ht(r.v.p, r.p.x) * it.q; t.n += it.q;
    });
    return t;
  }

  function renderCart() {
    var t = totals();
    $('#bhCartEmpty').hidden = items.length > 0;
    $('#bhCartBox').hidden = items.length === 0;
    cartList.innerHTML = items.map(function (it) {
      var r = byVariant[it.id]; if (!r) return '';
      var img = r.p.i ? '<img class="bh-devis__cImg" src="' + esc(thumb(r.p, 100)) + '" alt="" loading="lazy" width="44" height="44">' : '<div class="bh-devis__cImg"></div>';
      return '<div class="bh-devis__cItem" data-id="' + it.id + '">' + img +
        '<div><p class="bh-devis__cTitle">' + esc(r.p.main) + '</p><p class="bh-devis__cMeta">' + (r.p.vs.length > 1 ? esc(r.v.t) + ' · ' : '') + money(r.v.p) + ' TTC/u</p></div>' +
        '<div class="bh-devis__cLine">' + money(r.v.p * it.q) + '</div>' +
        '<div class="bh-devis__cRow"><span class="bh-devis__qty"><button type="button" class="bh-devis__qtyBtn" data-m aria-label="Diminuer">−</button><input type="number" class="bh-devis__qtyInput" value="' + it.q + '" min="1" inputmode="numeric" aria-label="Quantité"><button type="button" class="bh-devis__qtyBtn" data-p aria-label="Augmenter">+</button></span>' +
        '<button type="button" class="bh-devis__cRemove" data-rm>Retirer</button></div></div>';
    }).join('');
    $('#bhCartCount').textContent = t.n;
    $('#bhTotalHT').textContent = money(t.ht);
    $('#bhTotalTVA').textContent = money(t.ttc - t.ht);
    $('#bhTotalTTC').textContent = money(t.ttc);
    $('#bhMbarCount').textContent = t.n;
    $('#bhMbarTotal').textContent = money(t.ttc) + ' TTC';
    $('#bhMbar').hidden = t.n === 0 || !!(done && !done.hidden);
    $('#bhShareInput').hidden = true;
    if (!items.length) closeSheet();
    renderSuggest();
  }
  cartList.addEventListener('click', function (e) {
    var row = e.target.closest('.bh-devis__cItem'); if (!row) return;
    var id = parseInt(row.getAttribute('data-id'), 10); var it = findItem(id); if (!it) return;
    if (e.target.closest('[data-m]')) { if (it.q > 1) setQty(id, it.q - 1); }
    else if (e.target.closest('[data-p]')) setQty(id, it.q + 1);
    else if (e.target.closest('[data-rm]')) setQty(id, 0);
  });
  cartList.addEventListener('change', function (e) {
    var row = e.target.closest('.bh-devis__cItem'); if (!row) return;
    setQty(parseInt(row.getAttribute('data-id'), 10), Math.max(1, parseInt(e.target.value, 10) || 1));
  });
  $('#bhClear').addEventListener('click', function () { items = []; save(); refreshAll(); });

  // Suggestions complémentaires (metafield complementary_products)
  function renderSuggest() {
    var inQuote = {}; items.forEach(function (it) { var r = byVariant[it.id]; if (r) inQuote[r.p.h] = true; });
    var seen = {}, out = [];
    items.forEach(function (it) {
      var r = byVariant[it.id]; if (!r) return;
      (r.p.cp || []).forEach(function (h) {
        if (out.length < 3 && byHandle[h] && !inQuote[h] && !seen[h]) { seen[h] = true; out.push(byHandle[h]); }
      });
    });
    $('#bhSuggest').hidden = out.length === 0;
    $('#bhSuggestList').innerHTML = out.map(function (p) {
      var img = p.i ? '<img src="' + esc(thumb(p, 100)) + '" alt="" loading="lazy" width="40" height="40">' : '<div class="bh-devis__cImg"></div>';
      return '<div class="bh-devis__sItem">' + img + '<p>' + esc(p.main) + '<br><small>' + money(p.vs[0].p) + ' TTC</small></p>' +
        '<button type="button" class="bh-devis__sAdd" data-sh="' + esc(p.h) + '">Ajouter</button></div>';
    }).join('');
  }
  $('#bhSuggestList').addEventListener('click', function (e) {
    var b = e.target.closest('[data-sh]'); if (!b) return;
    var p = byHandle[b.getAttribute('data-sh')];
    if (p) { addItem(p.vs[0].id, 1); track('bh_devis_suggest_add', { sku: p.vs[0].s }); }
  });

  // ---------- Panneau mobile ----------
  var backdrop = $('#bhBackdrop');
  function openSheet() { if (!isMobile() || !items.length) return; cartEl.classList.add('is-sheet'); backdrop.hidden = false; document.documentElement.style.overflow = 'hidden'; }
  function closeSheet() { cartEl.classList.remove('is-sheet'); backdrop.hidden = true; document.documentElement.style.overflow = ''; }
  $('#bhMbar').addEventListener('click', function () { if (isMobile()) openSheet(); else $('#bhRecap').scrollIntoView({ behavior: 'smooth' }); });
  $('#bhSheetClose').addEventListener('click', closeSheet);
  backdrop.addEventListener('click', closeSheet);
  $('#bhSheetNext').addEventListener('click', function () { closeSheet(); $('#bhStep2').scrollIntoView({ behavior: 'smooth', block: 'start' }); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSheet(); });
  window.addEventListener('resize', function () { if (!isMobile()) closeSheet(); });

  // ---------- Import panier / préremplissage / partage ----------
  var importBtn = $('#bhImportCart');
  if (importBtn) {
    importBtn.addEventListener('click', function () {
      var cartData = []; try { cartData = JSON.parse($('#bhCartData').textContent); } catch (e) {}
      var n = 0;
      cartData.forEach(function (c) { if (byVariant[c.v] && !findItem(c.v)) { items.push({ id: c.v, q: c.q }); n++; } });
      save(); refreshAll(); importBtn.hidden = true;
      toast(n ? n + ' produit(s) du panier ajouté(s) au devis' : 'Les produits du panier sont déjà dans le devis');
      track('bh_devis_import_cart', { count: n });
    });
  }

  (function fromUrl() {
    var params = new URLSearchParams(window.location.search);
    var changed = false;
    var h = params.get('produit');
    if (h && byHandle[h]) {
      var p = byHandle[h];
      var vid = parseInt(params.get('variante'), 10);
      var v = (byVariant[vid] && byVariant[vid].p === p) ? byVariant[vid].v : p.vs[0];
      selIdx[p.h] = p.vs.indexOf(v);
      if (!findItem(v.id)) items.push({ id: v.id, q: 1 });
      toast('« ' + p.main + ' » ajouté à votre devis');
      track('bh_devis_add', { sku: v.s, quantity: 1, source: 'fiche_produit' });
      changed = true;
    }
    var sel = params.get('selection');
    if (sel) {
      var n = 0;
      sel.split('.').forEach(function (pair) {
        var bits = pair.split('-'); var id = parseInt(bits[0], 10); var q = parseInt(bits[1], 10) || 1;
        if (byVariant[id]) { var it = findItem(id); if (it) it.q = Math.max(it.q, q); else items.push({ id: id, q: q }); n++; }
      });
      if (n) { toast('Sélection partagée chargée (' + n + ' produit' + (n > 1 ? 's' : '') + ')'); track('bh_devis_share_open', { count: n }); }
      changed = true;
    }
    if (changed) {
      save();
      ['produit', 'variante', 'selection'].forEach(function (k) { params.delete(k); });
      var qs = params.toString();
      if (window.history && history.replaceState) history.replaceState(null, '', window.location.pathname + (qs ? '?' + qs : '') + window.location.hash);
    }
  })();

  $('#bhShare').addEventListener('click', function () {
    if (!items.length) return;
    var url = window.location.origin + window.location.pathname + '?selection=' + items.map(function (it) { return it.id + '-' + it.q; }).join('.');
    var input = $('#bhShareInput');
    function showInput() { input.value = url; input.hidden = false; input.focus(); input.select(); }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(function () { toast('Lien de la sélection copié'); }, function () { showInput(); toast('Copiez le lien ci-dessous'); });
    } else { showInput(); toast('Copiez le lien ci-dessous'); }
    track('bh_devis_share', { count: items.length });
  });

  // ---------- PDF (impression navigateur) ----------
  function printQuote(list) {
    list = list || items;
    if (!list.length) return;
    var t = totals(list);
    var date = new Date().toLocaleDateString('fr-FR', { day: '2-digit', month: 'long', year: 'numeric' });
    var rows = list.map(function (it) {
      var r = byVariant[it.id]; if (!r) return '';
      return '<tr><td>' + esc(r.p.t) + (r.p.vs.length > 1 ? '<br><small>' + esc(r.v.t) + '</small>' : '') + '</td><td>' + esc(r.v.s || '') + '</td>' +
        '<td class="n">' + it.q + '</td><td class="n">' + money(ht(r.v.p, r.p.x)) + '</td><td class="n">' + money(r.v.p) + '</td><td class="n">' + money(r.v.p * it.q) + '</td></tr>';
    }).join('');
    $('#bhPrint').innerHTML =
      '<div class="bh-p__head"><div><h1>BarberHouse</h1><div>Estimation de devis — sélection de produits</div></div><div style="text-align:right">' + esc(date) + '<br>' + esc(window.location.host) + '</div></div>' +
      '<table><thead><tr><th>Produit</th><th>SKU</th><th class="n">Qté</th><th class="n">PU HT</th><th class="n">PU TTC</th><th class="n">Total TTC</th></tr></thead><tbody>' + rows + '</tbody></table>' +
      '<div class="bh-p__tot"><div><span>Total HT</span><span>' + money(t.ht) + '</span></div><div><span>TVA</span><span>' + money(t.ttc - t.ht) + '</span></div><div class="big"><span>Total TTC</span><span>' + money(t.ttc) + '</span></div></div>' +
      '<div class="bh-p__note">' + esc(PRICE_NOTE) + '</div>' +
      '<div class="bh-p__foot">Document indicatif établi à partir des prix publics en vigueur le ' + esc(date) + '. Il ne constitue pas un devis ni une offre contractuelle.</div>';
    document.body.classList.add('bh-print-mode');
    var cleanup = function () { document.body.classList.remove('bh-print-mode'); window.removeEventListener('afterprint', cleanup); };
    window.addEventListener('afterprint', cleanup);
    track('bh_devis_pdf', { count: list.length, value: t.ttc / 100 });
    window.print();
    setTimeout(cleanup, 1000);
  }
  $('#bhPdf').addEventListener('click', function () { printQuote(); });

  // ---------- Formulaire / étapes ----------
  var form = $('#bhForm');
  var submitBtn = $('#bhSubmit');
  var hint = $('#bhSubmitHint');
  var offCat = $('#bhOffCatalog');
  var proRadio = $('#bhIsPro');
  var company = $('#bhCompany');
  var formFields = $('#bhFormFields');
  var locked = $('#bhLocked');
  var forceOpen = false;
  var steps = root.querySelectorAll('#bhStepper li');

  function hasContent() { return items.length > 0 || offCat.value.trim() !== ''; }
  function requiredFilled() {
    return Array.prototype.every.call(form.querySelectorAll('[required]'), function (f) {
      return f.type === 'checkbox' ? f.checked : f.value.trim() !== '';
    });
  }
  function updateSteps() {
    var unlocked = hasContent() || forceOpen;
    formFields.hidden = !unlocked;
    locked.hidden = unlocked;
    var filled = requiredFilled();
    var ok = hasContent() && filled;
    submitBtn.disabled = !ok;
    hint.hidden = ok;
    var current = !hasContent() ? 1 : (filled ? 3 : 2);
    steps.forEach(function (li) {
      var n = parseInt(li.getAttribute('data-step'), 10);
      li.classList.toggle('is-active', n === current);
      li.classList.toggle('is-done', n < current);
    });
    itemsField.value = buildBody();
  }
  function syncPro() { company.required = proRadio.checked; company.placeholder = proRadio.checked ? 'Entreprise / salon *' : 'Entreprise / salon (facultatif)'; updateSteps(); }
  root.querySelectorAll('input[name="contact[Type de client]"]').forEach(function (r) { r.addEventListener('change', syncPro); });
  var diffShip = $('#bhDiffShip');
  diffShip.addEventListener('change', function () { $('#bhShipFields').hidden = !diffShip.checked; });

  function addOffCatalog(text) {
    forceOpen = true;
    if (text) offCat.value = (offCat.value.trim() ? offCat.value.trim() + '\n' : '') + text;
    updateSteps();
    offCat.scrollIntoView({ behavior: 'smooth', block: 'center' });
    offCat.focus();
    track('bh_devis_off_catalog', { query: text || '' });
  }
  $('#bhUnlockOff').addEventListener('click', function () { addOffCatalog(''); });

  function buildBody() {
    var lines = ['Nouvelle demande de devis — site BarberHouse', '', 'Produits demandés :'];
    items.forEach(function (it) {
      var r = byVariant[it.id]; if (!r) return;
      lines.push('- ' + r.p.t + (r.p.vs.length > 1 ? ' | Variante : ' + r.v.t : '') + (r.v.s ? ' | SKU : ' + r.v.s : '') +
        ' | Qté : ' + it.q + ' | ' + money(ht(r.v.p, r.p.x)) + ' HT / ' + money(r.v.p) + ' TTC l\'unité (prix public)' +
        ' | Stock Shopify : ' + (r.v.a ? 'disponible' : 'rupture') + ' | ' + window.location.origin + r.p.u);
    });
    if (!items.length) lines.push('(aucun produit catalogue — voir « Produits hors catalogue »)');
    var t = totals();
    lines.push('', 'Total au prix public : ' + money(t.ht) + ' HT / ' + money(t.ttc) + ' TTC (' + t.n + ' article(s))');
    lines.push('Tarif préférentiel à transmettre après étude.');
    if (items.length) {
      lines.push('', 'Lignes pour brouillon de commande (SKU x quantité) :');
      items.forEach(function (it) { var r = byVariant[it.id]; if (r) lines.push((r.v.s || r.p.t) + ' x ' + it.q); });
    }
    return lines.join('\n');
  }

  form.addEventListener('input', updateSteps);
  form.addEventListener('change', updateSteps);
  form.addEventListener('submit', function (e) {
    if (!hasContent() || !requiredFilled()) { e.preventDefault(); updateSteps(); return; }
    itemsField.value = buildBody();
    store(LAST_KEY, { items: items.slice(), at: Date.now() }, true);
    var t = totals();
    track('bh_devis_submit', { lines: items.length, units: t.n, value: t.ttc / 100, off_catalog: offCat.value.trim() !== '' });
    submitBtn.disabled = true;
    submitBtn.textContent = 'Envoi en cours…';
  });

  // ---------- Rendu global ----------
  function refreshAll() { renderCart(); renderProducts(); updateSteps(); }
  syncPro();
  refreshAll();
})();
